import { Chip } from '@material-ui/core'
import styled from 'styled-components'

export const Tags: typeof Chip = styled(Chip)`
    font-family: Roboto-Bold;
    max-width: 100% !important;
`